import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

import { Field, ReadOnlyField, TextboxField, TextAreaField, NumberField, CheckboxField, DropdownField, RadioListField, DateField, DateTimeField, FileField, UserField, DropdownPanelField, HeaderField, SeparatorField, IntegerField, ImageUrlField, MultiSelectField, UrlField, CustomInputField, Separator1Field, MultiSelectListField } from '../models';
import { UscStoreService } from './usc-store/usc-store.service';
import { UscCampaignService } from './usc-campaign/usc-campaign.service';
import { AuthService } from './auth.service';

@Injectable()
export class FieldService {
    constructor(
        private formBuilder: FormBuilder,
    ) { }

    toFormGroup(fields: Field<any>[]) {
        let group: any = {};
        fields.forEach(field => {
            var value = field.value;
            if (value && field.display_type == DateField.control_type) {
                var date_value = new Date(value);
                var month = date_value.getMonth() + 1;
                var date = date_value.getDate();
                var month_string = month > 9 ? month.toString() : "0" + month.toString();
                var date_string = date > 9 ? date.toString() : "0" + date.toString();
                value = `${date_value.getFullYear()}-${month_string}-${date_string}`;
            }
            group[field.key] = field.required ? new FormControl(value || '', Validators.required) : new FormControl(value || '');
            if (field.display_type == MultiSelectField.control_type) {
                group[field.key] = this.formBuilder.array([]);
            } else if (field.display_type == MultiSelectListField.control_type) {
               group[field.key] = this.formBuilder.array([]);
            }
        });
        return new FormGroup(group);
    }

    // add new field control here to have it loaded to the form fields
    configToFormFields(config: any): Array<Field<any>> {
        let formFields: Array<Field<any>> = [];
        config.forEach(c => {
            switch (c.display_type) {
                case ReadOnlyField.control_type: formFields.push(new ReadOnlyField(c)); break;
                case TextboxField.control_type: formFields.push(new TextboxField(c)); break;
                case TextAreaField.control_type: formFields.push(new TextAreaField(c)); break;
                case IntegerField.control_type: formFields.push(new IntegerField(c)); break;
                case NumberField.control_type: formFields.push(new NumberField(c)); break;
                case CheckboxField.control_type: formFields.push(new CheckboxField(c)); break;
                case DropdownField.control_type: formFields.push(new DropdownField(c)); break;
                case RadioListField.control_type: formFields.push(new RadioListField(c)); break;
                case DateField.control_type: formFields.push(new DateField(c)); break;
                case DateTimeField.control_type: formFields.push(new DateTimeField(c)); break;
                case FileField.control_type: formFields.push(new FileField(c)); break;
                case UserField.control_type: formFields.push(new UserField(c)); break;
                case DropdownPanelField.control_type: formFields.push(new DropdownPanelField(c)); break;
                case HeaderField.control_type: formFields.push(new HeaderField(c)); break;
                case SeparatorField.control_type: formFields.push(new SeparatorField(c)); break;
                case Separator1Field.control_type: formFields.push(new Separator1Field(c)); break;
                case ImageUrlField.control_type: formFields.push(new ImageUrlField(c)); break;
                case MultiSelectField.control_type: formFields.push(new MultiSelectField(c)); break;
                case MultiSelectListField.control_type: formFields.push(new MultiSelectListField(c)); break;
                case UrlField.control_type: formFields.push(new UrlField(c)); break;
                case CustomInputField.control_type: formFields.push(new CustomInputField(c)); break;
            }
        });
        return formFields;
    }

    formValueToFormFields(formValue: any, formFields: Array<Field<any>>): Array<Field<any>> {
        formFields.forEach(f => {
            if (f.isInput() && !f.isReadOnly()) {
                switch (f.display_type) {
                    case CheckboxField.control_type:
                        f.value = formValue[f.key] != "" ? formValue[f.key] : false;
                        break;
                    // HACK: there is a bug within angular 4.0 where the formValue (form.value) does not return the proper value for array fields,
                    // thus, there is a workaround to update the formValue on valueChange event within the Modal component.  
                    // therefore, the current formFields value is already up-to-date.
                    case MultiSelectField.control_type: break;
                    case MultiSelectListField.control_type: break;
                    default:
                        f.value = formValue[f.key];
                        break;
                }
            }
        });
        return formFields;
    }

    mergeFormFields(orgFormFields: Array<Field<any>>, newFormFields: Array<Field<any>>) {
        var extraFields: Array<Field<any>> = [];
        orgFormFields.forEach(f => {
            var fieldFound = null;
            for (var i = 0; i < newFormFields.length; i++) {
                if (f.sn_ID != '' && f.sn_ID === newFormFields[i].sn_ID) {
                    fieldFound = f;
                }
            }
            if (fieldFound == null) {
                extraFields.push(f);
            }
        });

        extraFields.forEach(f => {
            newFormFields.push(f);
        });
        return extraFields;
    }

    getFormFields(viewFields: any, data): Array<Field<any>> {
        let formFields: Array<Field<any>> = this.configToFormFields(viewFields);
        if (formFields && data) {
            formFields.forEach(f => {
                var value = Field.getFormValue(f, data);
                if (value) f.value = value;
            });
        }
        return formFields;
    }

    updateDataWithFormValues(formFields: Array<Field<any>>, data) {
        if (formFields && data) {
            formFields.forEach(f => {
                if (f.value) {
                    data[f.key] = f.value;
                }
            });
        }
        return data;
    }

    formFieldsToViewItem(formFields: Array<Field<any>>) {
        let item: Object = {};
        formFields.forEach(f => {
            item[f.key] = f.value;
        });

        return item;
    }

    processListItems(view: string, item: any, field: Field<any>, list_items: any, formField: Field<any>[]) {
        let filtered_list_items = list_items;
        // var filtered_list_items:any;

        // if (this.authService.isUSCellCampaign()) {
        //     filtered_list_items = this.uscCampaignService.processListItems(view, item, field, list_items, formField);
        // } else {
        //     filtered_list_items = JSON.parse(JSON.stringify(list_items));
        // }

        return filtered_list_items;
    }


    // getItemCustomFieldValue(item, field): string {
    //     if (item.json_custom_fields) {
    //         var custom_fields = JSON.parse(item.json_custom_fields);
    //         var field = custom_fields.find(f => f.CustomFieldName == field);
    //         if (field) return field.CustomFieldValue;
    //     }
    //     return null;
    // }

    // setItemCustomFieldValue(item, field, value) {
    //     if (item.json_custom_fields) {
    //         var custom_fields = JSON.parse(item.json_custom_fields);
    //         var field = custom_fields.find(f => f.CustomFieldName == field);
    //         if (field) { field.CustomFieldValue = value; }
    //         item.json_custom_fields = JSON.stringify(custom_fields);
    //     }
    // }

    getItemCustomFieldValue(item, field): string {
        var custom_fields = item.custom_fields ? item.custom_fields : item.json_custom_fields ? JSON.parse(item.json_custom_fields) : null;
        if (custom_fields) {
            var field = custom_fields.find(f => f.CustomFieldName == field);
            if (field) return field.CustomFieldValue;
        }
        return null;
    }
    
    setItemCustomFieldValue(item, field, value) {
        if (item.json_custom_fields) {
            var custom_fields = JSON.parse(item.json_custom_fields);
            var field = custom_fields.find(f => f.CustomFieldName == field);
            if (field) { field.CustomFieldValue = value; }
            item.json_custom_fields = JSON.stringify(custom_fields);
        }
        if (item.custom_fields) {
            var field = item.custom_fields.find(f => f.CustomFieldName == field);
            if (field) { field.CustomFieldValue = value; }
        }
    }
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/field.service.ts